// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PFtp","colMin":"styles_colMin__3AaRC"};